import Vue from 'vue';
import VueEsc from 'vue-esc';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import money from 'v-money';
import VTooltip from "v-tooltip";
import { ZiggyVue } from 'ziggy';
import { Ziggy } from './ziggy';

require( './vue_directives' );
require('./vue_components');

window.Lang = require('lang.js');
require('./lang');

window.Vue = Vue;
import VueInstantSearch from 'vue-instantsearch';
Vue.use(VueInstantSearch);

window.OSPEvent = new Vue();

Vue.use(VTooltip);
Vue.use(ElementUI, {locale});
Vue.use(VueEsc);
Vue.use(money, {precision: 2, prefix: '$'});
Vue.use(ZiggyVue, Ziggy);

Vue.mixin({
    // don't remove this key
    listeners: {},

    methods: {
        trans (...args) {
            return Lang.get.apply(Lang, args);
        },

        transChoice (...args) {
            return Lang.choice.apply(Lang, args);
        },

        moment (...args) {
            return moment.apply(moment, args);
        },
    },

    created () {
        // binding global watches to their function
        for (let event in this.$options.listeners) {
            let func = this.$options.listeners[event];

            if (typeof func === 'function') {
                OSPEvent.$on(event, func.bind(this));
            } else {
                console.error(`[listeners] ${event} is not a function`);
            }
        }
    },
});

Vue.filter('titleCase', str => str.titleCase());

Vue.filter('snakeToTitle', str => str.snakeToTitle());

window.app = new Vue({
    el: '#app',
});
